import { dispatcher, DispatcherEvents } from "../dispatcher";
import { AppType, getAppType } from "./nativeHelpers";

function cordovaHandleIoxUsbPlugin() {
    if (window.cordova.plugins.IoxUSBManager) {
        window.cordova.plugins.IoxUSBManager.setCallback((dataFromPlugin) => {
            if (dataFromPlugin.hasOwnProperty("attached")) {
                dispatcher.trigger(DispatcherEvents.IoxAttached, dataFromPlugin.attached);
            } else {
                dispatcher.trigger(DispatcherEvents.NewIoxData, dataFromPlugin, true);
            }
        });
    }
}

function nativeSDKIoxUsbPlugin() {
    window.addEventListener("iox.data", function(data: any) {
        let ioxData = data.detail;
        if (ioxData.hasOwnProperty("attached")) {
            dispatcher.trigger(DispatcherEvents.IoxAttached, ioxData.attached);
        } else {
            dispatcher.trigger(DispatcherEvents.NewIoxData, ioxData, false);
        }
    });
    window.addEventListener("ioxble.godevicedata", function(data: any) {
        dispatcher.trigger(DispatcherEvents.NewIoxData, data.detail, false);
    });
    window.addEventListener("ioxble.error", function(data: any) {
        dispatcher.trigger(DispatcherEvents.IoxBleError, data.detail, false);
    });
}

export function handleIoxConnection() {
    switch (getAppType()) {
        case AppType.CordovaApp:
            cordovaHandleIoxUsbPlugin();
            break;
        case AppType.NativeSdk:
            nativeSDKIoxUsbPlugin();
            break;
        default:
            break;
    }
}